export const CHAPTERS_CALL_REQUEST = "CHAPTERS_CALL_REQUEST";
export const CHAPTERS_CALL_SUCCESS = "CHAPTERS_CALL_SUCCESS";
export const CHAPTERS_CALL_FAILURE = "CHAPTERS_CALL_FAILURE";
